import { render, staticRenderFns } from "./DesignRirekisho001Preview.vue?vue&type=template&id=369f75ec"
import script from "./DesignRirekisho001Preview.vue?vue&type=script&setup=true&lang=ts"
export * from "./DesignRirekisho001Preview.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports